import * as Yup from 'yup';
import { isAfter } from 'date-fns';
import { lookupsJson } from '@ourbranch/lookups';
import { localToUtcTime } from '@ourbranch/date-fns-helpers';
import { NEW_CUSTOMER_HOME_SECURITY } from 'core/helpers/constants';

export const connectedHomeSchema = (isAdvancedConnectedHome, isAgency) =>
  Yup.object().shape({
    connectedHome: Yup.object()
      .shape({
        monitored: Yup.string(),
        moistureDevices: Yup.number()
          .min(0, 'Number of moisture devices must be a positive number')
          .required('Number of moisture devices is required, if none enter 0'),
        motionDetectingDevices: Yup.number()
          .min(0, 'Number of motion-detecting devices must be a positive number')
          .test(
            'ch-on',
            'Number of motion-detecting devices is required, if none enter 0',
            (value, context) =>
              !context.parent.monitored || isAdvancedConnectedHome || context.parent?.monitored === 'N' || value >= 0
          )
          .nullable(),
        smokeDetectingDevices: Yup.number()
          .min(0, 'Number of smoke-detecting devices must be a positive number')
          .required('Number of smoke-detecting devices is required, if none enter 0'),
        theftPreventionDevices: Yup.number()
          .min(0, 'Number of theft-prevention devices must be a positive number')
          .required('Number of theft-prevention devices is required, if none enter 0'),
        autoWaterShutoffDevices: Yup.boolean().required(),
        providerName: Yup.string()
          .test(
            'ch-on',
            'Connected home provider name is required',
            (value, context) => !context.parent.monitored || context.parent?.monitored === 'N' || value?.length
          )
          .test(
            'connected-home-provider-invalid',
            'There must be a connected home provider that is monitoring the home for this discount. Please put in the name of the provider or turn off the discount to continue.',
            function (value) {
              // Check if the provider is an invalid value ("P" or in comp rater case, "ADT")
              const fromCompRater = this.options.context.global.fromRC1;
              return value !== 'P' && (fromCompRater ? value !== 'ADT' : true);
            }
          )
          .test(
            'connected home new sign up still available',
            'The new sign up offer for this home security provider has expired, please delete the discount and add again with a different provider',
            function (value) {
              if (
                this.options.context.global.homeSecurityPartnerCustomerType === NEW_CUSTOMER_HOME_SECURITY.SIGN_UP_TYPE
              ) {
                if (
                  lookupsJson.securityProviders.find((p) => p.id === value)?.[
                    isAgency ? 'agencyPromotionDeadlineToBind' : 'internalPromotionDeadlineToBind'
                  ] &&
                  isAfter(
                    localToUtcTime(new Date(), this.options.context.home.homeLocation.state),
                    localToUtcTime(
                      new Date(
                        lookupsJson.securityProviders.find((p) => p.id === value)?.[
                          isAgency ? 'agencyPromotionDeadlineToBind' : 'internalPromotionDeadlineToBind'
                        ]
                      ),
                      this.options.context.home.homeLocation.state
                    )
                  )
                ) {
                  return false;
                }
                if (
                  !lookupsJson.securityProviders.find((p) => p.id === value)?.[
                    isAgency ? 'agencyPromotionDeadlineToBind' : 'internalPromotionDeadlineToBind'
                  ]
                ) {
                  // all CHD new sign ups must have an end date now, even if it's in 2099
                  return false;
                }
              }
              return true;
            }
          )
      })
      .nullable()
  });
